/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useBitacora } from "../hooks/useBitacora";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ProyeccionDiariaBitacora = ({
  isVisible,
  toggle,
  fecha,
  variedad,
  id_variedad,
}) => {
  const { getBitacora, isLoading } = useBitacora();
  const [data, steData] = useState([]);

  useEffect(() => {
    const getBitacoraData = async () => {
      const response = await getBitacora(fecha, id_variedad);
      steData(response);
    };
    if (id_variedad) {
      getBitacoraData();
    }
  }, [id_variedad, fecha]);

  return (
    <Modal isOpen={isVisible} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>
        Bitacora {moment(fecha).format("DD/MM/YYYY")} {variedad}
      </ModalHeader>
      <ModalBody>
        {isLoading ? (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <FontAwesomeIcon icon="fas fa-spinner" spin />
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Campo</th>
                  <th scope="col">Cantidad</th>
                  <th scope="col">Usuario</th>
                  <th scope="col">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {data?.length === 0 ? (
                  <tr>
                    <td
                      colSpan={4}
                      style={{ textAlign: "center", padding: "30px" }}
                    >
                      Sin registros
                    </td>
                  </tr>
                ) : (
                  data?.map((item) => (
                    <tr key={item.id_bitacora}>
                      <td>{item.campo}</td>
                      <td>{item.cantidad}</td>
                      <td>{item.usuario}</td>
                      <td>
                        {moment(item.fecha_regitro).local("es-mx").format("LL")}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};
